import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const KeyList = Loadable({
  loader: () => import('./KeysListPage'),
  loading: () => <Loading withContentWrapper />,
});

export const KeyForm = Loadable({
  loader: () => import('./KeyFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const KeyValues = Loadable({
  loader: () => import('./KeyValuesPage'),
  loading: () => <Loading withContentWrapper />,
});
